<template>
  <div class="home-wrapper main-wrapper">
    <div class="top-title-box">
      <!-- 首页标题 -->
      <div class="title">
        <!-- <img src="@/assets/img/icon-1.png" alt="" /> -->
        首页推荐
        <!-- <router-link to="/eSports" v-if="PerfectArchives && PerfectArchives[0]"
          >赛事活动（当期比赛时间，{{
            PerfectArchives[0].ActivityStartTime
          }}）</router-link
        > -->
      </div>
      <!-- 公告 -->
      <div class="more">
        <div class="notice" v-if="JSON.stringify(notice) !== '{}'">
          <img src="@/assets/images/home/notice.png" alt />
          <div class="three-info bbsInfo" v-if="bbsData.length > 0">
            <vue-seamless-scroll :data="bbsData" :class-option="bbsOption">
              <div class="info-item">
                <p>{{ bbsData[0].Title }}:{{ bbsData[0].Content }}</p>
              </div>
            </vue-seamless-scroll>
          </div>
        </div>
      </div>
    </div>

    <div class="top-box">
      <el-row :gutter="20">
        <el-col :span="17">
          <div class="left-box">
            <div class="carousel">
              <div class="carousel-box">
                <el-carousel
                  height="270px"
                  direction="vertical"
                  trigger="click"
                  indicator-position="none"
                  :initial-index="itemIndex"
                  ref="carousel"
                  :interval="6000"
                  @change="handleChange"
                  :active-index="itemIndex"
                >
                  <el-carousel-item
                    v-for="(item, index) in lbData"
                    :key="index"
                  >
                    <img
                      :src="item.ImgUrl"
                      width="100%"
                      height="270px"
                      alt
                      @click="handleCarousel(item)"
                    />
                  </el-carousel-item>
                </el-carousel>
              </div>

              <div class="listItem">
                <div
                  class="item ellipsis"
                  v-for="(item, index) in lbData"
                  :key="index"
                  @click="setIndex(index)"
                  :style="{
                    background: itemIndex == index ? '#ff3636' : '',
                    color: itemIndex == index ? '#fff' : '',
                  }"
                >
                  <span :class="index == itemIndex ? 'active' : ''">{{
                    item.Describe
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="7">
          <div class="right-box">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="大家都在玩" name="1">
                <router-link
                  :to="`/gameDetail/${item.ProductID}`"
                  v-for="(item, index) in everyonePlayData"
                  :key="index"
                  class="item-content"
                >
                  <div class="img-content">
                    <img
                      :src="
                        item &&
                        item.gameInfoEntity.Img +
                          '?x-oss-process=image/resize,h_60'
                      "
                      alt
                    />
                  </div>
                  <div class="text-box">
                    <h3 class="ellipsis">
                      {{ item && item.gameInfoEntity.Name }}
                    </h3>
                    <div class="ellipsis">
                      {{ item && item.gameInfoEntity.Labels }}
                    </div>
                  </div>
                </router-link>
              </el-tab-pane>
              <el-tab-pane label="最新上架" name="2">
                <router-link
                  :to="`/gameDetail/${item.ProductID}`"
                  v-for="(item, index) in newGameList.slice(0, 3)"
                  :key="index"
                  class="item-content"
                >
                  <div class="img-content">
                    <img :src="item && item.gameInfoEntity.Img" alt />
                  </div>
                  <div class="text-box">
                    <h3 class="ellipsis">
                      {{ item && item.gameInfoEntity.Name }}
                    </h3>
                    <div
                      class="ellipsis"
                      v-if="item && item.gameInfoEntity.UpdateZCPTTime"
                    >
                      {{
                        item &&
                        item.gameInfoEntity.UpdateZCPTTime.substr(0, 10)
                      }}上架
                    </div>
                  </div>
                </router-link>
              </el-tab-pane>
              <el-tab-pane label="最近玩的" name="3">
                <router-link
                  :to="`/gameDetail/${item.ProductID}`"
                  v-for="(item, index) in historGame"
                  :key="index"
                  class="item-content"
                  v-if="historGame.length"
                >
                  <div class="img-content">
                    <img :src="item.Img" alt />
                  </div>
                  <div class="text-box">
                    <h3 class="ellipsis">{{ item.GameName }}</h3>
                    <div class="ellipsis">
                      <router-link
                        :to="`/userCenter/myItems?GameID=${item.GameID}`"
                        v-if="item.HasArchive"
                        >查看存档</router-link
                      >
                      <span v-else>没有存档</span>
                    </div>
                  </div>
                </router-link>

                <router-link to="/home" class="item-content" v-else>
                  <div class="no-game">
                    <el-button type="primary" plain>去玩游戏</el-button>
                  </div>
                </router-link>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 热门游戏 -->
    <div class="hot-game">
      <div class="title-box">
        <span class="title">
          <img src="@/assets/img/icon-2.png" alt="" />
          {{ netBarVIP ? "热门游戏" : "周免游戏" }}
          <span v-if="!netBarVIP">每周精选，限时免费</span>
        </span>
        <router-link :to="netBarVIP ? '/home' : '/weeklyFreeGame'" class="more">
          更多游戏
          <i class="el-icon-d-arrow-right"></i>
        </router-link>
      </div>
      <ul class="game-box">
        <li
          v-for="(item, index) in hotGameList"
          :key="index"
          @click="toFreetoplay(item.gameInfoEntity.Name, item.ProductID)"
          v-show="index < 5"
        >
          <div class="icon" v-if="!netBarVIP">
            免费玩<br />
            价值：￥{{
              item &&
              item.gameInfoEntity.Originalprice &&
              item &&
              item.gameInfoEntity.Originalprice.toString().split(".")[0]
            }}
          </div>
          <div class="content" v-if="item && item.gameInfoEntity">
            <div
              :style="{
                height: '100px',
                background: `url(${
                  item && item.gameInfoEntity.PicList[0]
                }?x-oss-process=image/resize,h_106)`,
                backgroundSize: '100% 100px',
                borderRadius: '6px 6px 0 0',
              }"
            ></div>
            <h4
              v-if="
                item.gameInfoEntity.Type == 2 || item.gameInfoEntity.Type == 3
              "
            >
              {{ beautySub(item.gameInfoEntity.Name, 4) }}
              <span class="cloud-archiving">支持存档</span>
            </h4>
            <h4 v-else>{{ item.gameInfoEntity.Name }}</h4>
            <div v-if="netBarVIP">
              <div class="show">
                <el-button class="start">登录游戏</el-button>
              </div>
              <div class="hidden">
                <div class="tag-box">
                  <el-tag
                    v-for="(i, index) in item.gameInfoEntity.Labels.split(',')"
                    :key="index"
                    >{{ i }}</el-tag
                  >
                </div>
              </div>
            </div>

            <div class="free-time" v-else>
              本周{{ netBarId == 44126 ? "网鱼" : "" }}限时免费
            </div>
          </div>
        </li>
      </ul>
    </div>

    <div class="hot-game">
      <div class="title-box">
        <span class="title">
          <img src="@/assets/img/icon-2.png" alt="" />
          新上架商品
        </span>
        <router-link to="/home" class="more">
          更多游戏
          <i class="el-icon-d-arrow-right"></i>
        </router-link>
      </div>
      <ul class="game-box">
        <li
          v-for="(item, index) in newGameList"
          :key="index"
          @click="toFreetoplay(item.gameInfoEntity.Name, item.ProductID)"
        >
          <div class="content" v-if="item && item.gameInfoEntity">
            <div
              :style="{
                height: '100px',
                background: `url(${item.gameInfoEntity.PicList[0]}?x-oss-process=image/resize,h_106)`,
                backgroundSize: '100% 100px',
                borderRadius: '6px 6px 0 0',
              }"
            ></div>
            <h4
              v-if="
                item.gameInfoEntity.Type == 2 || item.gameInfoEntity.Type == 3
              "
            >
              {{ beautySub(item.gameInfoEntity.Name, 4) }}
              <span class="cloud-archiving">支持存档</span>
            </h4>
            <h4 v-else>{{ item.gameInfoEntity.Name }}</h4>
            <div class="show">
              <el-button class="start">登录游戏</el-button>
            </div>
            <div class="hidden">
              <div class="tag-box">
                <el-tag
                  v-for="(i, index) in item.gameInfoEntity.Labels.split(',')"
                  :key="index"
                  >{{ i }}</el-tag
                >
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <!-- 长条广告位 -->
    <!-- <div class="img-box" v-if="netBarVIP && zsAdImg.length">
      <a href="javascript:;" @click="linkTo(zsAdImg[2].Url)" class="pic-item">
        <img :src="zsAdImg[2].ImgUrl" alt />
      </a>
    </div>
    
    <div class="img-box" v-if="hjAdImg.length">
      <a href="javascript:;" @click="linkTo(hjAdImg[2].Url)" class="pic-item">
        <img :src="hjAdImg[2].ImgUrl" alt />
      </a>
    </div> -->

    <!-- 启动广告 -->
    <el-dialog
      :visible.sync="dialogVisible"
      custom-class="no-title-dialog"
      width="500px"
      v-if="startAd.length && startAd[0] && IsLuckDraw"
      center
      @close="closeStartAd"
    >
      <div class="blind-box-img" style="padding: 30px">
        <a
          href="javascript:;"
          @click="linkTo(startAd[0].Url, 1)"
          style="display: block"
        >
          <img :src="startAd[0].ImgUrl" width="100%" alt="" />
        </a>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetActivity2,
  GetTop1Msg,
  GetHomePageGames,
  GetNavigationList,
  GetGameKeyword,
  GetGameListNew,
  GetHistorGameProductList,
} from "@/api";
import { mapGetters } from "vuex";
import cMethods from "@/util/cMethods.js";
import vueSeamlessScroll from "vue-seamless-scroll";
// import CLiveRoom from "@/views/components/CLiveRoom.vue";

// 节流函数
const delay = (function () {
  let timer = 0;
  return function (callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();

export default {
  name: "Home",
  components: {
    vueSeamlessScroll,
    // CLiveRoom,
  },
  computed: {
    ...mapGetters(["isLogin", "netBarId", "netBarVIP", "userInfo"]),
    bbsOption() {
      return {
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: 1, // 开始无缝滚动的数据量 this.bbsData.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 2, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
  data() {
    return {
      itemIndex: 0,
      bbsData: [],
      dialogVisible: false,
      gameList: [],
      hotGameList: [],
      historGame: [],
      lbData: [],
      everyonePlayData: [],
      // hjAdImg: [],
      // zsAdImg: [],
      startAd: [],
      name: "",
      notice: {},
      IsLuckDraw: false,
      newGameList: [],
      adObj: null,
      activeName: "1",
      PerfectArchives: [],
      reverse: true,

      timer: null,
    };
  },
  created() {
    if (this.userInfo && this.userInfo.IsLuckDraw) {
      this.IsLuckDraw = true;
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  mounted() {
    // 广告图(没有打开)
    // if (!sessionStorage.getItem("hideStartAd")) {
    //   this._GetNavigationList(7);
    // }

    this._GetNavigationList(2);

    if (this.netBarId) {
      // 获取赛事列表
      this._GetGameList();
      
      // 获取网吧信息
      this.$store.dispatch("_GetNetbarInfo", {
        netBarId: parseInt(this.netBarId),
        callback: (netbarInfo) => {
          // 如果是钻石版跳转列表页
          if (this.netBarVIP) {
            // 推荐游戏
            this._GetHomePageGames(1);
            // 广告图
            // this._GetNavigationList(2);
          } else {
            // 推荐游戏
            this._GetHomePageGames(2);
            // 广告图
            // this._GetNavigationList(1);
          }
        },
      });
    }
    // 获取公告
    this._GetTop1Msg();

    // 热门搜索大家都在玩
    this._GetGameKeyword();

    // 新上架商品
    this._GetNewGame();
  },
  methods: {
    handleCarousel(item) {
      if (item.Url && item.Url.indexOf("http") !== -1) {
        cMethods.OpenIeUrl(item.Url);
      } else {
        this.$router.push(item.Url);
      }
    },
    handleChange(e) {
      this.itemIndex = e;
    },
    setIndex(i) {
      this.itemIndex = i;
      this.$refs.carousel.setActiveItem(i);
    },
    toLive() {
      this.$statistic(["B", "首页", "直播", "点击人数"]);
      this.$router.push("/eSports");
    },

    // 获取游戏列表
    async _GetGameList(index) {
      if (this.netBarId) {
        let params = {
          netbarId: this.netBarId,
          pageSize: 3,
          pageIndex: 1,
          state: "2",
          userId: (this.userInfo && this.userInfo.ConsumerId) || 0,
          gameName: "绝地求生",
        };
        let res = await GetActivity2(params);

        if (res.StatusCode == 200) {
          this.PerfectArchives = res.Items.reverse();
          if (index === "2" && this.PerfectArchives.length) {
            let t = new Date(this.PerfectArchives[0].ActivityStartTime);
            this.startTime = t.getTime();
            clearTimeout(this.timer);
          }
        }
      } else {
        this.$message({
          message: "获取网吧ID失败！",
          type: "error",
        });
      }
    },
    async handleClick(tab, event) {
      // 获取赛事列表
      // this._GetGameList(tab.name);
      if (tab.name == "3") {
        if (this.userInfo) {
          let params = {
            vipId: this.userInfo.ConsumerId,
            rows: 3,
            page: 1,
          };
          let res = await GetHistorGameProductList(params);

          if (res.StatusCode == 200) {
            const { Data } = JSON.parse(res.Object);
            this.historGame = Data;
          }
        } else {
          eventBus.$emit("getQrCode");
        }
      }
    },

    // 获取新上架商品
    async _GetNewGame() {
      let params = {
        source: 3,
        keyword: "",
        pageSize: 5,
        pageIndex: 1,
        labels: "",
        platformId: "",
        // isNewGame: true,
      };
      let res = await GetGameListNew(params);
      if (res.StatusCode == 200) {
        this.newGameList = res.Items;
      }
    },
    linkTo(url, num) {
      let reg =
        /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\*\+,;=.]+$/;
      if (!reg.test(url)) {
        if (url.indexOf("/link") > -1) {
          this.$router.push({ path: "/link", query: { url: url } });
        } else {
          this.$router.push(url);
        }
      } else {
        cMethods.OpenIeUrl(url);
      }
      if (num == 1) {
        this.closeStartAd();
      }
    },
    // 关闭启动广告
    closeStartAd() {
      this.dialogVisible = false;
      sessionStorage.setItem("hideStartAd", true);
    },
    // 获取广告图
    async _GetNavigationList(type) {
      let params = {
        type: type,
      };
      let res = await GetNavigationList(params);
      if (res.StatusCode) {
        // if (type == 1) {
        //   this.hjAdImg = res.Object;
        // }
        // if (type == 2) {
        //   this.zsAdImg = res.Object;
        // }
        if (type == 2) {
          this.lbData = res.Object;
        }
        if (type == 7) {
          this.startAd = res.Object;
          if (
            this.startAd.length &&
            this.startAd[0] &&
            this.startAd[0].ImgUrl
          ) {
            this.dialogVisible = true;
          }
        }
      }
    },
    async _GetGameKeyword() {
      let res = await GetGameKeyword({});
      if (res.StatusCode == 200) {
        if (res.Object.length) {
          this.everyonePlayData = res.Object.slice(0, 3);
        }
      }
    },
    // 公告
    async _GetTop1Msg() {
      let params = {};
      let res = await GetTop1Msg(params);
      if (res.StatusCode == 200) {
        this.bbsData = [];
        if (res.Object != null) {
          this.notice = res.Object;
        } else {
          this.notice = {};
        }
        this.bbsData.push(this.notice);
      }
    },
    //获取平台、网吧用户和游戏数据
    async _GetHomePageGames(type) {
      let params = {
        type: type,
        navigationType: 3,
      };
      let res = await GetHomePageGames(params);
      if (res.StatusCode == 200) {
        // let data = res.Object;
        // this.gameList = data.slice(0, 3);
        // this.hotGameList = data.slice(3, 8);

        this.hotGameList = res.Object;
        if (this.hotGameList.length) {
          if (this.netBarId !== "44126") {
            this.hotGameList = this.hotGameList.filter(
              (item) => item && item.ProductID !== "PC251009000003"
            );
          }

          this.setWeeklyFreeGame(this.hotGameList);
        }
      }
    },
    setWeeklyFreeGame(arr) {
      let strArr = [];
      arr.map((item) => {
        strArr.push(item.ProductID);
      });
      sessionStorage.setItem("weeklyFreeGame", JSON.stringify(strArr));
    },
    // 热门游戏跳转
    toFreetoplay(Name, ProductID) {
      // this.$statistic(["B", "本周最热游戏", "点击", Name]);
      this.$router.push(`/gameDetail/${ProductID}`);
    },
    beautySub(str, len) {
      var reg = /[\u4e00-\u9fa5]/g, //匹配中文
        slice = str.substring(0, len),
        chineseCharNum = ~~(slice.match(reg) && slice.match(reg).length),
        realen = slice.length * 2 - chineseCharNum;
      return str.substr(0, realen) + (realen < str.length ? "..." : "");
    },

    toLink(ProductID, Name) {
      this.$router.push("/gameDetail/" + ProductID);
      this.$statistic(["B", "热门搜索", "点击", Name]);
    },
  },
  watch: {
    //监听搜索，300ms执行一次查询方法（去搜索）
    name() {
      delay(() => {
        if (this.name) {
          this.$router.push("/home?name=" + this.name);
        }
      }, 300);
    },
  },
};
</script>

<style lang="scss" scoped>
.home-wrapper {
  position: relative;

  .qualifications {
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 99;
    width: 258px;
    height: 118px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    background: $white-col;

    .title {
      width: 248px;
      height: 30px;
      line-height: 30px;
      padding-left: 10px;
      border-bottom: 1px solid $border-col;
      color: #e71e88;
      font-size: 16px;

      img {
        vertical-align: middle;
        margin-right: 5px;
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      @include font_col3();

      p {
        margin: 10px 0;
        font-size: 16px;
      }

      a {
        width: 120px;
        height: 30px;
        line-height: 30px;
        display: block;
        text-align: center;
        background: #e71e88;
        border-radius: 0px 6px 0px 6px;
        color: $white-col;
      }
    }
  }

  .top-title-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 28px;
    line-height: 28px;
    font-size: 16px;
    box-sizing: border-box;
    @include font_col3();
    .title {
      width: 60%;
      a {
        margin-left: 20px;
        border-left: 3px solid $red-col;
        padding-left: 10px;
        // padding-bottom: 5px;
      }
    }
    .more {
      width: 40%;

      .notice {
        display: flex;
        height: 26px;
        // background: rgba(0, 0, 0, 0.6);
        img {
          width: 22px;
          height: 18px;
          margin-top: 4px;
          margin-right: 10px;
        }

        p {
          font-size: 16px;
          // color: #ff3636;
          @include font_col6();
          margin-right: 20px;
        }

        .info-item {
          height: 26px;
          line-height: 26px;
          overflow: hidden;
          display: flex;
        }

        .bbsInfo {
          // color: #fff;
          overflow: hidden;
        }
      }
    }
  }

  .top-box {
    height: 268px;
    justify-content: space-between;
    .left-box {
      height: 268px;
      overflow: hidden;
      border-radius: 4px;
      .carousel {
        display: flex;
        justify-content: space-between;
        height: 268px;
        .carousel-box {
          width: 100%;
          height: 268px;
          img {
            cursor: pointer;
          }
        }
        .listItem {
          width: 160px;
          @include item_bg_col();
          .item {
            padding: 0 10px;
            height: 38px;
            line-height: 38px;
            @include font_col6();
            border-bottom: 1px solid rgba(155, 155, 156, 0.3);
            cursor: pointer;
          }
        }
      }
    }
    .right-box {
      width: 298px;
      height: 268px;
      float: right;
      border-radius: 6px;
      position: relative;
      box-sizing: border-box;
      // @include item_bg_col();

      .el-tabs {
        border-radius: 6px;
        // @include item_bg_col();

        ::v-deep .el-tabs__item {
          height: 30px;
          line-height: 30px;
          @include font_col3();
          font-size: 14px;
          padding: 0 10px;
        }

        ::v-deep .el-tabs__header {
          margin-bottom: 0;
          @include item_bg_col();
        }

        ::v-deep .el-tabs__item.is-active,
        ::v-deep .el-tabs__item:hover {
          color: $red_col;
        }

        ::v-deep .el-tabs__active-bar {
          background-color: $red_col;
        }
        ::v-deep .el-tabs__content {
          padding-top: 0;
        }
      }
      .item-content {
        @include item_bg_col();
        margin: 6px 0;
        padding: 5px 12px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 64px;
        // border-bottom: 1px solid rgba(155, 155, 156, 0.3);
        &:last-child {
          border-bottom: none;
        }
        &:hover {
          cursor: pointer;
          // @include item_bg_col();
          // background: #fff3f3;
          transform: translateY(-5px);
          transition: 0.2s ease;
          box-shadow: -2px 0px 10px 0px rgb(0 0 0 / 20%);
        }
        .img-content {
          width: 106px;
          height: 60px;
          img {
            width: 100%;
            height: 100%;
            display: block;
          }
        }
        .text-box {
          width: 154px;
          display: flex;
          flex-direction: column;
          font-size: 12px;
          @include font_col6();
          h3 {
            margin-bottom: 8px;
            font-size: 15px;
          }
          a {
            text-decoration: underline;
            color: $red_col;
          }
        }
      }
      .no-game {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        .el-button {
          padding: 6px 12px;
        }
      }
    }
  }

  .hot-game {
    margin-top: 10px;
    height: 180px;
    border-radius: 6px;

    .title-box {
      height: 20px;
      line-height: 20px;
      font-size: 16px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      @include font_col3();

      .title {
        display: flex;
        align-items: center;

        img {
          width: 20px;
          margin-right: 8px;
        }

        span {
          font-size: 14px;
          margin-left: 15px;
          color: #ff3636;
        }
      }

      .more {
        float: right;
        font-size: 14px;
        margin-right: 10px;
        @include font_col3();
      }
    }

    .game-box {
      margin-top: 8px;
      display: flex;
      justify-content: space-between;

      li {
        width: 190px;
        height: 150px;
        border-radius: 6px;
        box-sizing: border-box;
        text-align: center;
        @include item_bg_col();
        position: relative;

        .icon {
          width: 111px;
          height: 36px;
          display: flex;
          align-items: center;
          justify-content: center;

          position: absolute;
          top: -5px;
          left: 5px;
          color: #fff;
          font-size: 12px;
          line-height: 14px;
          background: url("./../assets/img/left_icon1.png") no-repeat;
        }

        h4 {
          font-size: 15px;
          line-height: 24px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          @include font_col3();

          .cloud-archiving {
            padding: 2px 5px;
            margin-left: 10px;
            background: $linear-col;
            border-radius: 4px;
            color: $white-col;
            font-size: 12px;
            line-height: 18px;
          }
        }

        .free-time {
          width: 180px;
          padding: 3px 10px;
          margin: 0 auto;
          border-radius: 4px;
          color: #ff682d;
          background: transparent;
          border: 1px solid #ff682d;
          box-sizing: border-box;
        }

        .tag-box {
          overflow: hidden;
          // margin-top: 5px;
          height: 18px;

          .el-tag {
            margin: 0 5px;
            background: none !important;
            height: 18px;
            line-height: 18px;
            border-radius: 4px;
            @include font_col9();
          }
        }

        .show {
          display: none;

          .start {
            width: 180px;
            padding: 5px 10px;
            border: transparent;
            color: $white-col;
            background: $red-col;
          }
        }
      }

      li:hover {
        transform: translateY(-5px);
        transition: 0.2s ease;
        cursor: pointer;
        box-shadow: -2px 0px 10px 0px rgba(0, 0, 0, 0.2);

        .show {
          display: block;
        }

        .hidden {
          display: none;
        }

        h4 {
          color: $red-col;
        }

        .free-time {
          color: #fff;
          background: linear-gradient(90deg, #ff9a68 0%, #ff6868 100%);
        }
      }
    }
  }

  .img-box {
    height: 92px;
    margin-top: 14px;

    img {
      width: 100%;
      height: 93px;
      border-radius: 6px;
    }
  }

  // 广告闪光效果
  .pic-item {
    position: relative;
    overflow: hidden;
    display: block;
  }

  .pic-item:hover {
    transform: translateY(-5px);
    transition: 0.5s ease;
  }

  .pic-item:after {
    position: absolute;
    left: -100%;
    /*改变left的值，让其相对box影藏*/
    top: 0;
    width: 30%;
    height: 100%;
    content: "";
    /* Safari 5.1 - 6.0 */
    background: -webkit-linear-gradient(
      left,
      rgba(255, 255, 255, 0) 0,
      rgba(255, 255, 255, 0.6) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    /* Opera 11.1 - 12.0 */
    background: -o-linear-gradient(
      left,
      rgba(255, 255, 255, 0) 0,
      rgba(255, 255, 255, 0.6) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    /* Firefox 3.6 - 15 */
    background: -moz-linear-gradient(
      left,
      rgba(255, 255, 255, 0) 0,
      rgba(255, 255, 255, 0.6) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    /* 标准的语法 */
    background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0) 0,
      rgba(255, 255, 255, 0.6) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    transform: skewX(-45deg);
  }

  .pic-item:hover:after {
    left: 150%;
    transition: 1s ease;
  }
}

.no-title-dialog {
  padding: 50px;
}
</style>
